import { DescriptionInterface, PublishLotInterface } from "../utils/interface";
import Api from "./Api";

export const getDescription = (data: DescriptionInterface) => Api.post('/lots/description', data);

export const publish = (data: PublishLotInterface) => Api.post('/lots', data);

export const uploadVideo = (data: any) => Api.request('/bucket/video', 'POST', {
  'Content-Type':'multipart/form-data',
}, data);

export const wantPublish = (data: any) => Api.post('/lots/want-publish', data);
